import { call, CallEffect, put, PutEffect } from 'redux-saga/effects';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import {
  RevisionHistoryActionInstance
} from '../services/RevisionHistoryAction';
import {
  requestFailed,
  RequestFailedAction
} from '../../app/actions/RequestFailedAction';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { RevisionHistoryAction } from '../../app/actions/spaces/RevisionHistoryAction';
import { getCorrectEntityIdForActions } from '../../app/sagas/spaces/SpacesSagaHelpers';
import { reloadSpaceIfUpdatingCurrentSpace } from '../../app/sagas/spaces/content/RefreshContentSagas';

export function* handleRevisionHistoryAction(action: RevisionHistoryAction) {
  try {
    const entityId = yield call(getCorrectEntityIdForActions, action.content.contentType, action.content.id);
    yield call(openRevisionHistoryDialog, { ...action.content, id: entityId });

    const didReload = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.content]);
    if (!didReload) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openRevisionHistoryDialog(content: IContentInfo): Promise<IResult> {
  const revisionHistoryService = RevisionHistoryActionInstance;
  switch (content.contentType) {
    case 'workbook':
      return revisionHistoryService.showWorkbookRevisionHistory(content);
    case 'datasource':
      return revisionHistoryService.showDataSourceRevisionHistory(content);
    case 'flow':
      return revisionHistoryService.showFlowRevisionHistory(content);
  }
}
